import React from "react";
import styles from "../styles/DXFAcquisitionPopup.module.css";

interface DXFAcquisitionPopupProps {
  isOpen: boolean;
  onClose: () => void;
  requiredAmount: string;
}

const DXFAcquisitionPopup: React.FC<DXFAcquisitionPopupProps> = ({
  isOpen,
  onClose,
  requiredAmount,
}) => {
  const handlePlayGame = () => {
    window.location.href = "/";
    onClose();
  };

  const handleJoinCommunity = () => {
    window.open("https://t.me/DXFCommunity", "_blank", "noopener");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className={styles.dxfAcquisitionOverlay}>
      <div className={styles.dxfAcquisitionPopup}>
        <div className={styles.dxfAcquisitionHeader}>
          <h2>Get DXF Tokens</h2>
          <button onClick={onClose} className={styles.dxfAcquisitionClose} type="button">
            ×
          </button>
        </div>

        <div className={styles.dxfAcquisitionContent}>
          <div className={styles.dxfInfo}>
            <div className={styles.dxfRequired}>
              <span className={styles.label}>Required:</span>
              <span className={styles.amount}>{requiredAmount} DXF</span>
            </div>
          </div>

          <div className={styles.dxfMessage}>
            Play the game to mine DXF tokens or join our community on Telegram to get random airdrops.
          </div>

          <div className={styles.dxfActions}>
            <button onClick={handlePlayGame} className={`${styles.dxfActionBtn} ${styles.primary}`} type="button">
              Play Game
            </button>
            <button onClick={handleJoinCommunity} className={`${styles.dxfActionBtn} ${styles.secondary}`} type="button">
              Join Telegram
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DXFAcquisitionPopup;